import { ControlIcons } from 'owa-control-icons';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';
import { assertNever } from 'owa-assert';
import strings from 'owa-strings/owa-calendar-event-icons';

type EventIconType = 'Private' | 'HasAttachments' | 'Recurring' | 'RecurringException';

export function getCalendarEventIcon(eventDetails: EventIconType): IIconProps {
    switch (eventDetails) {
        case 'Private':
            return {
                iconName: ControlIcons.Lock,
                title: strings.calendarEventPrivateIconTitle,
            };
        case 'HasAttachments':
            return {
                iconName: ControlIcons.Attach,
                title: strings.calendarEventAttachmentIconTitle,
            };
        case 'Recurring':
            return {
                iconName: ControlIcons.SyncOccurence,
                title: strings.calendarEventRecurringIconTitle,
            };
        case 'RecurringException':
            return {
                iconName: ControlIcons.UnsyncOccurence,
                title: strings.calendarEventRecurringIconExceptionTitle,
            };
        default:
            return assertNever(eventDetails);
    }
}
